import { ChevronRightIcon } from "@heroicons/react/outline";
import { RECIPIENT_COLOUR_MAP } from "../utils";
import { SignatureConfig } from "../interfaces";
import { useTranslation } from "react-i18next";

interface Props {
  signatureConfig: SignatureConfig;
}

function SignatureRequestEmailRecipients(props: Props) {

  const { signatureConfig } = props;

  const { t } = useTranslation();

  const hubspotContactLabel1 = signatureConfig.recipientEmail1.match(/{{__hscontact_(.+?)(?::(.+))?}}/);
  const hubspotContactLabel2 = signatureConfig.recipientEmail2.match(/{{__hscontact_(.+?)(?::(.+))?}}/);
  const hubspotContactLabel3 = signatureConfig.recipientEmail3.match(/{{__hscontact_(.+?)(?::(.+))?}}/);
  const hubspotContactLabel4 = signatureConfig.recipientEmail4.match(/{{__hscontact_(.+?)(?::(.+))?}}/);

  return (
    <div className="flex items-center relative my-1 flex-shrink-0 gap-1 overflow-x-auto scrollbar-hidden w-[700px] pr-[64px]">
      <div className={`${RECIPIENT_COLOUR_MAP[1][1]} relative text-white text-xs rounded-full px-2 pt-1 font-semibold flex-shrink-0`}>
        1. {hubspotContactLabel1
          ? hubspotContactLabel1[2] || t("Contact")
          : signatureConfig.recipientEmail1 || t("Email Required")
        }
        {!signatureConfig.recipientEmail1 &&
          <div className='bg-yellow w-2 h-2 rounded-full absolute -right-0.5 top-0'></div>
        }
      </div>
      {signatureConfig.numRecipients >= 2 &&
        <div className='flex items-center gap-1 flex-shrink-0'>
          <ChevronRightIcon className='w-4 h-4 text-gray-400' />
          <div className={`${RECIPIENT_COLOUR_MAP[2][1]} relative text-white text-xs rounded-full px-2 pt-1 font-semibold flex-shrink-0`}>
            2. {hubspotContactLabel2
              ? hubspotContactLabel2[2] || t("Contact")
              : signatureConfig.recipientEmail2 || t("Email Required")
            }
            {!signatureConfig.recipientEmail2 &&
              <div className='bg-yellow w-2 h-2 rounded-full absolute -right-0.5 top-0'></div>
            }
          </div>
        </div>
      }
      {signatureConfig.numRecipients >= 3 &&
        <div className='flex items-center gap-1 flex-shrink-0'>
          <ChevronRightIcon className='w-4 h-4 text-gray-400' />
          <div className={`${RECIPIENT_COLOUR_MAP[3][1]} relative text-white text-xs rounded-full px-2 pt-1 font-semibold flex-shrink-0`}>
            3. {hubspotContactLabel3
              ? hubspotContactLabel3[2] || t("Contact")
              : signatureConfig.recipientEmail3 || t("Email Required")
            }
            {!signatureConfig.recipientEmail3 &&
              <div className='bg-yellow w-2 h-2 rounded-full absolute -right-0.5 top-0'></div>
            }
          </div>
        </div>
      }
      {signatureConfig.numRecipients >= 4 &&
        <div className='flex items-center gap-1 flex-shrink-0'>
          <ChevronRightIcon className='w-4 h-4 text-gray-400' />
          <div className={`${RECIPIENT_COLOUR_MAP[4][1]} relative text-white text-xs rounded-full px-2 pt-1 font-semibold flex-shrink-0`}>
            4. {hubspotContactLabel4
              ? hubspotContactLabel4[2] || t("Contact")
              : signatureConfig.recipientEmail4 || t("Email Required")
            }
            {!signatureConfig.recipientEmail4 &&
              <div className='bg-yellow w-2 h-2 rounded-full absolute -right-0.5 top-0'></div>
            }
          </div>
        </div>
      }
    </div>
  );
}

export default SignatureRequestEmailRecipients;
